import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { atcApiReq, atcApiRes } from './interfaces'

class AtcApi implements apiInterface.IAtcApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  atcApi = async (params: atcApiReq.IAtcApiReq): Promise<atcApiRes.IAtcApiRes> => {
    const res = await this.ctx.get('/atc_api', {
      token: process.env.REACT_APP_ATC_TOKEN,
      ...params
    })
    return res.data
  }
}

export default AtcApi
